import { AppWhiteLogoIcon } from "components/svg-icons";
import { useContext } from "react";
import { ProjectContext } from "context/ProjectProvider";
import ProjectLogoIcon from "components/svg-icons/project-logo";
import { TruncatedTextWithTooltip } from "components/cell-renders";
import { DateTimePanel } from "components/navbar/navbar";
import AAccountMenu from "../a-account-menu";

function ANavbar() {
  const { projectDetails } = useContext(ProjectContext);

  return (
    <div className="flex justify-between w-full bg-ciq-primary-200 text-white hover:text-white px-4">
      <div className="flex">
        <div className="flex items-center border-0 border-r border-solid py-2 pr-3 border-black">
          <div className="w-[120px] flex">
            <AppWhiteLogoIcon />
          </div>
        </div>

        <div className="flex items-center space-x-2 text-white hover:text-white pl-3">
          <ProjectLogoIcon size={30} />
          <div className="flex space-x-1">
            <div className="font-medium">
              <TruncatedTextWithTooltip text={projectDetails?.name} />
            </div>
            <div>|</div>
            <DateTimePanel />
          </div>
        </div>
      </div>
      <div className="flex space-x-4 items-center h-full">
        <div className="pl-3 py-2 flex justify-center items-center border-0 border-l border-solid border-black">
          <AAccountMenu />
        </div>
      </div>
    </div>
  );
}

export default ANavbar;
